import { Image, ImageWithText2 } from "../models/post";
// @ts-ignore
import { CKEditor } from '@ckeditor/ckeditor5-react';
// @ts-ignore
import BalloonEditor from '@ckeditor/ckeditor5-build-balloon';
import styled from "styled-components";
import { useEffect, useState } from "react";
import ChangeImageModal from "./change-image-modal";
import { DeleteButton } from "./text-component";
import { CloseRounded } from "@mui/icons-material";
import { Wrapper } from "./post-components";
import InfoStyle from "./info-style";

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr 4fr 1fr;
  gap: 1rem;
  position: relative;
`;

const ImageStyle = styled.div`
  border-radius: 12px;
  border: 1px solid #EEEEEE;
	overflow: hidden;
	cursor: pointer;
	margin-bottom: .5rem;
	&:hover {
		border: 1px solid #c8c8c8;
	}
	img {
		width: 100%;
		object-fit: cover;
		vertical-align: middle;
	}
`;

export function ImageText2Component(props: {
  imageWithText2: ImageWithText2;
  update: (image1: Image, image2: Image, text1: string, text2: string) => void;
  deleteContent: () => void;
}) {
  const [text1, setText1] = useState(props.imageWithText2.text1);
  const [text2, setText2] = useState(props.imageWithText2.text2);
  const [link1, setLink1] = useState(props.imageWithText2.image1.link);
  const [link2, setLink2] = useState(props.imageWithText2.image2.link);
  const [src1, setSrc1] = useState(props.imageWithText2.image1.src);
  const [src2, setSrc2] = useState(props.imageWithText2.image2.src);

  const onChange1 = (_event: any, editor: { getData: any; }) => {
    setText1(editor.getData());
  };
  const onChange2 = (_event: any, editor: { getData: any; }) => {
    setText2(editor.getData());
  };
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  useEffect(() => {
    props.update({ src: src1, alt: "", info: "", link: link1 }, { src: src2, alt: "", info: "", link: link2 }, text1, text2);
  }, [src1, src2, text1, text2, props, link1, link2]);

  return <Grid onMouseMove={() => setShowDelete(true)} onMouseEnter={() => setShowDelete(true)} onMouseLeave={() => setShowDelete(false)}>
    <DeleteButton show={showDelete} onClick={props.deleteContent}>
      <CloseRounded />
    </DeleteButton>
    <div />
    <div>
      <div>
        <ImageStyle onClick={() => setShowModal1(true)}>
          <img src={src1} alt={"Bild 1"} />
        </ImageStyle>
      </div>
      <div style={{ marginBottom: "0.5rem" }}>
        <Wrapper>
          <InfoStyle value={link1} onChange={(e) => setLink1(e.target.value)} placeholder="Link" />
        </Wrapper>
      </div>
      <div>
        <CKEditor editor={BalloonEditor} data={text1} config={{
          toolbar: ['heading', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo'],
          placeholder: "Text schreiben..."
        }} onChange={onChange1} />
      </div>
    </div>
    <div>
      <div>
        <ImageStyle onClick={() => setShowModal2(true)}>
          <img src={src2} alt={"Bild 2"} />
        </ImageStyle>
      </div>
      <div style={{ marginBottom: "0.5rem" }}>
        <Wrapper>
          <InfoStyle value={link2} onChange={(e) => setLink2(e.target.value)} placeholder="Link" />
        </Wrapper>
      </div>
      <div>
        <CKEditor editor={BalloonEditor} data={text2} config={{
          toolbar: ['heading', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo'],
          placeholder: "Text schreiben..."
        }} onChange={onChange2} />
      </div>
    </div>
    {showModal1 && <ChangeImageModal close={() => setShowModal1(false)} updateImage={src => setSrc1(src)} />}
    {showModal2 && <ChangeImageModal close={() => setShowModal2(false)} updateImage={src => setSrc2(src)} />}
    <div />
  </Grid>;
}
